import { client as privateClient, publicClient } from "queryClient";
import { Expansion, ExpansionSelectionSet, ExpansionShortened } from "types";

export const getAllExpansionList = async (
  nextTokenParam: string | null = null,
  prevExpansionList: Expansion[] = [],
): Promise<Expansion[]> => {
  const params: any = {
    limit: 1000,
  };

  if (nextTokenParam) {
    params.nextToken = nextTokenParam;
  }

  const { data, nextToken } = await privateClient.models.Expansion.list(params);

  const expansionList = [...prevExpansionList, ...data];

  return nextToken
    ? getAllExpansionList(nextToken, expansionList)
    : expansionList;
};

export const getExpansionListForBuyingProducts = async (
  isAuth: boolean,
  nextTokenParam: string | null = null,
  prevExpansionList: Expansion[] = [],
): Promise<Expansion[]> => {
  const client = isAuth ? privateClient : publicClient;

  const { data, nextToken } =
    await client.models.Expansion.expansionsByOutOfStockSelection(
      {
        outOfStockSelection: "Include",
      },
      {
        limit: 1000,
        nextToken: nextTokenParam,
      },
    );

  const expansionList = [...prevExpansionList, ...data];

  return nextToken
    ? getExpansionListForBuyingProducts(isAuth, nextToken, expansionList)
    : expansionList;
};

export const getAllExpansionListShortened = async (
  isAuth: boolean,
  nextTokenParam: string | null = null,
  prevExpansionList: ExpansionShortened[] = [],
): Promise<ExpansionShortened[]> => {
  const client = isAuth ? privateClient : publicClient;

  const { data, nextToken } = await client.models.Expansion.list({
    limit: 1000,
    selectionSet: ExpansionSelectionSet,
    nextToken: nextTokenParam,
  });

  const expansionList = [...prevExpansionList, ...data];

  console.log("getAllExpansionListShortened: ", expansionList);

  return nextToken
    ? getAllExpansionListShortened(isAuth, nextToken, expansionList)
    : expansionList;
};

export const getExpansion = async (id: string): Promise<Expansion | null> => {
  const { data } = await privateClient.models.Expansion.get({
    id,
  });

  return data;
};
